import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "../../Components/Button";
import Footer from "../../Components/Footer";
import Loader from "../../Components/Loader";
import Navbar from "../../Components/Navbar";
import text_truncate from "../../Components/TextTruncate";
import { getAllCategories } from "../../Store/api/category.api";
import { getAllMenu } from "../../Store/api/listingMenu.api";
import { StateType } from "../../Store/reducer/index.reducer";
import { MenuProduct } from "../../Store/type/listingMenu.type";
import { Drawer } from "antd";
import type { DrawerProps } from "antd/es/drawer";
import { day, device_time } from "../Category";
import { BiSearch } from "react-icons/bi";
import { AiFillFire } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import { PRODCUCTIMAGE_BASE_URL } from "../../Constants";
import { getAllTags } from "../../Store/api/tag.api";
import GeneralTitle from "../../Components/GeneralTitle";

const ListingMenu = ({ subDomain }: any) => {
    const dispatch = useDispatch<any>();
    const { id, restaurantid } = useParams();
    const [searchTerm, setSearchTerm] = useState("");
    const [filtervisible, setFilterVisible] = useState(false);
    const [menuvisible, setMenuVisible] = useState(false);
    const [tag, setTag] = useState<number[]>([]);
    const [selectedTag, setSelectedTag] = useState<number[]>([]);
    const [openSearch, setOpenSearch] = useState(false);
    const [menuCategory, setMenuCategory] = useState<number[]>([]);
    const [filterPlacement, setFilterPlacement] =
        useState<DrawerProps["placement"]>("left");
    const [menuPlacement, setMenuPlacement] =
        useState<DrawerProps["placement"]>("right");
    subDomain && GeneralTitle(subDomain);
    let navigate = useNavigate();

    const { loader } = useSelector((state: StateType) => state.menu);

    const menuDetails = useSelector((state: StateType) => state.menu?.menu);

    const dietTag = useSelector((state: StateType) => state.tags?.tags);
    const categoryRem = useSelector(
        (state: StateType) => state.menu?.menu?.data
    );
    const { categoryRes } = useSelector((state: StateType) => state.category);
    const curr = useSelector(
        (state: StateType) => state.category?.categoryRes?.currency
    );
    const currencyArr = curr?.split("-");
    const openSearchHandler = (e: any) => {
        e.preventDefault();
        setOpenSearch(!openSearch);
    };
    const onCancel = (e: any) => {
        e.preventDefault();
        setOpenSearch(!openSearch);
    };
    const handleFilter = () => {
        setTag(selectedTag);
        setFilterVisible(false);
    };
    const onClose = () => {
        setFilterVisible(false);
    };
    const menuClose = () => {
        setMenuVisible(false);
    };
    const showFilterDrawer = () => {
        setFilterVisible(true);
    };
    const showMenuDrawer = () => {
        setMenuVisible(true);
    };
    const handleCheckbox = (id: number) => {
        if (tag.includes(id)) {
            const filteredTag = tag.filter((item) => item !== id);
            setSelectedTag(filteredTag);
        } else {
            setSelectedTag([...tag, id]);
        }
    };
    const handleMenuCheck = (id: number) => {
        const dataa: any = { id, menuCategory: String(menuCategory) };
        subDomain && id && dispatch(getAllMenu(dataa));
        setMenuVisible(false);
        if (!menuCategory.includes(id)) {
            setMenuCategory([...menuCategory, id]);
        }
    };
    useEffect(() => {
        const data: any = { id, tag: String(tag) };
        subDomain && id && dispatch(getAllMenu(data));
        subDomain && restaurantid && dispatch(getAllTags(restaurantid));
        subDomain &&
            dispatch(
                getAllCategories(
                    subDomain,
                    device_time,
                    { navigate: navigate },
                    day
                )
            );

        window.scrollTo({
            top: 0,
            left: 0,
        });
    }, [tag, subDomain]);
    return (
        <>
            <Navbar showArrow showVenue={subDomain} />
            {loader ? (
                <Loader classType="loading-spinner" />
            ) : (
                <div className="whole_wrapper">
                    {categoryRem && (
                        <div className="listing-menu">
                            <div className="top-bar">
                                <div className="topbar_left">
                                    <div className="search-icon">
                                        <BiSearch
                                            className="bisearch"
                                            onClick={openSearchHandler}
                                        />
                                    </div>
                                    <div
                                        className="filter-icon"
                                        onClick={showFilterDrawer}
                                    >
                                        <img src="/Images/filter.png" />
                                    </div>
                                </div>
                                <div
                                    className="topbar_right"
                                    onClick={showMenuDrawer}
                                >
                                    View-menu
                                    <BsChevronDown className="viewmenu_arrow" />
                                </div>
                            </div>
                            <div
                                className={
                                    openSearch
                                        ? "search-bar active"
                                        : "search-bar"
                                }
                            >
                                <div className="input-search">
                                    <input
                                        type="text"
                                        onChange={(event) => {
                                            setSearchTerm(event.target.value);
                                        }}
                                    />
                                    <BiSearch
                                        className="bisearch_inner-icon"
                                        onClick={openSearchHandler}
                                    />
                                </div>
                                <div className="cancel-btn" onClick={onCancel}>
                                    Cancel
                                </div>
                            </div>

                            <div className="menu_wrapper">
                                {/* <h2>{menuDetails.category?.name}</h2> */}

                                <div className="menu_innerbox">
                                    {menuDetails?.data
                                        ?.filter((val) => {
                                            if (searchTerm == "") {
                                                return val;
                                            } else if (
                                                val.name
                                                    .toLowerCase()
                                                    .includes(
                                                        searchTerm.toLowerCase()
                                                    )
                                            ) {
                                                return val;
                                            }
                                        })
                                        ?.map(
                                            (
                                                item: MenuProduct,
                                                index: number
                                            ) => {
                                                return (
                                                    <>
                                                        <div className="subcat_wrapper">
                                                            {item?.products
                                                                ?.length >
                                                                0 && (
                                                                <div className="cat_name">
                                                                    {item?.name}
                                                                </div>
                                                            )}
                                                            <div className="menuitems_wrap">
                                                                {item?.products?.map(
                                                                    (
                                                                        subcat: any,
                                                                        i: number
                                                                    ) => {
                                                                        return (
                                                                            <>
                                                                                <Link
                                                                                    className="lm_link"
                                                                                    to={
                                                                                        subcat.status ==
                                                                                        0
                                                                                            ? ""
                                                                                            : `/detailmenu/${subcat.id}`
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            subcat.photo
                                                                                                ? "menu_itemsactive"
                                                                                                : subcat.sold ==
                                                                                                  0
                                                                                                ? " menu_items menuuu"
                                                                                                : "menu_items"
                                                                                        }
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {/* {subcat.sold ==
                                                                                            0 && (
                                                                                            <div
                                                                                                className={
                                                                                                    subcat.photo
                                                                                                        ? "sold_out"
                                                                                                        : "sold_out soldinactive"
                                                                                                }
                                                                                            >
                                                                                                Sold
                                                                                                Out
                                                                                            </div>
                                                                                        )} */}
                                                                                        {subcat.sold ==
                                                                                            0 && (
                                                                                            <>
                                                                                                <div
                                                                                                    className={
                                                                                                        subcat.photo ==
                                                                                                        0
                                                                                                            ? "sold_status "
                                                                                                            : "sold_status status_active"
                                                                                                    }
                                                                                                >
                                                                                                    <div>
                                                                                                        Sold
                                                                                                        Out
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        )}
                                                                                        {subcat?.photo && (
                                                                                            <div
                                                                                                className={
                                                                                                    subcat.sold ==
                                                                                                    0
                                                                                                        ? "image_overlay listingproduct_img"
                                                                                                        : "imagenormal listingproduct_img"
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={`${PRODCUCTIMAGE_BASE_URL}/${subcat.photo}`}
                                                                                                    alt="menu"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        <div
                                                                                            className={
                                                                                                !subcat.photo
                                                                                                    ? "menu-wholecontent"
                                                                                                    : subcat.sold ==
                                                                                                      0
                                                                                                    ? "menuinnercontent_opacity"
                                                                                                    : "menu_inner_content"
                                                                                            }
                                                                                        >
                                                                                            <div className="menu_subcontentI">
                                                                                                <div
                                                                                                    className={
                                                                                                        subcat.is_hot ==
                                                                                                        1
                                                                                                            ? "data_popular"
                                                                                                            : subcat.is_popular
                                                                                                            ? "data_popular"
                                                                                                            : "data_normal"
                                                                                                    }
                                                                                                >
                                                                                                    {subcat.is_popular ==
                                                                                                    1 ? (
                                                                                                        <div className="menu_status">
                                                                                                            <span>
                                                                                                                Popular
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        ""
                                                                                                    )}
                                                                                                    {subcat.is_hot ==
                                                                                                    1 ? (
                                                                                                        <div className="aifire">
                                                                                                            <AiFillFire className="aifire-icon" />
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        ""
                                                                                                    )}
                                                                                                </div>
                                                                                                <h4>
                                                                                                    {
                                                                                                        subcat.name
                                                                                                    }
                                                                                                </h4>
                                                                                                {subcat.is_hot ? (
                                                                                                    <p>
                                                                                                        {text_truncate(
                                                                                                            {
                                                                                                                str: subcat.description,
                                                                                                                length: 20,
                                                                                                                ending: null,
                                                                                                            }
                                                                                                        )}
                                                                                                    </p>
                                                                                                ) : subcat.is_popular ? (
                                                                                                    <p>
                                                                                                        {text_truncate(
                                                                                                            {
                                                                                                                str: subcat.description,
                                                                                                                length: 20,
                                                                                                                ending: null,
                                                                                                            }
                                                                                                        )}
                                                                                                    </p>
                                                                                                ) : (
                                                                                                    <p>
                                                                                                        {text_truncate(
                                                                                                            {
                                                                                                                str: subcat.description,
                                                                                                                length: 39,
                                                                                                                ending: null,
                                                                                                            }
                                                                                                        )}
                                                                                                    </p>
                                                                                                )}
                                                                                            </div>
                                                                                            <div className="menu_subcontent">
                                                                                                <div className="price">
                                                                                                    {currencyArr?.length &&
                                                                                                        currencyArr[0]}
                                                                                                    &nbsp;
                                                                                                    {
                                                                                                        subcat?.mrp
                                                                                                    }
                                                                                                </div>

                                                                                                <div className="menu__GVD">
                                                                                                    {subcat?.tags
                                                                                                        ?.slice(
                                                                                                            0,
                                                                                                            2
                                                                                                        )
                                                                                                        ?.map(
                                                                                                            (
                                                                                                                tag: any,
                                                                                                                index: number
                                                                                                            ) => {
                                                                                                                return (
                                                                                                                    <span
                                                                                                                        key={
                                                                                                                            index
                                                                                                                        }
                                                                                                                    >
                                                                                                                        {
                                                                                                                            tag
                                                                                                                        }
                                                                                                                    </span>
                                                                                                                );
                                                                                                            }
                                                                                                        )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Link>
                                                                            </>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                );
                                            }
                                        )}
                                </div>
                            </div>
                        </div>
                    )}

                    <Footer />
                </div>
            )}
            <Drawer
                className="listing_drawer"
                title="Dietary options"
                placement={filterPlacement}
                onClose={onClose}
                open={filtervisible}
                width={320}
            >
                <div className="filter__drawer">
                    <div className="filter_content_wrapper">
                        {dietTag?.map((diet: any, index: number) => {
                            return (
                                <>
                                    <label
                                        className="drawer_dietry_content"
                                        key={index}
                                    >
                                        <span>
                                            {text_truncate({
                                                str: diet?.name,
                                                length: 20,
                                                ending: null,
                                            })}
                                        </span>
                                        <input
                                            type="checkbox"
                                            onChange={() => {
                                                handleCheckbox(diet.id);
                                            }}
                                        />
                                    </label>
                                </>
                            );
                        })}
                    </div>
                </div>
                <div className="filter_applybtn" onClick={handleFilter}>
                    <button>Apply</button>
                </div>
                {/* <div className="listing_apply_btn" onClick={handleFilter}>
                    <button>APPLY</button>
                </div> */}
            </Drawer>

            <Drawer
                className="viewmenu_drawer"
                title="Drawer with extra actions"
                placement={menuPlacement}
                onClose={menuClose}
                open={menuvisible}
                width={280}
            >
                {categoryRes?.categories?.map((category: any, i: number) => {
                    return (
                        <>
                            <div
                                className="menu_categoryitem"
                                onClick={() => handleMenuCheck(category.id)}
                                key={i}
                            >
                                {text_truncate({
                                    str: category?.name,
                                    length: 22,
                                    ending: null,
                                })}
                            </div>
                        </>
                    );
                })}
            </Drawer>
        </>
    );
};

export default ListingMenu;
